import { ApiKeyData, UsageData, API_ACTIONS } from './actions';

interface ApiState {
  // Data
  apiKeyData: ApiKeyData | null;
  usageData: UsageData | null;

  // Loading states
  loading: boolean;
  refreshing: boolean;
  updatingUsage: boolean;

  // Error state
  error: string | null;
}

const initialState: ApiState = {
  apiKeyData: null,
  usageData: null,
  loading: false,
  refreshing: false,
  updatingUsage: false,
  error: null,
};

const apiReducer = (state = initialState, action: any): ApiState => {
  switch (action.type) {
    // Initialize API data
    case API_ACTIONS.INITIALIZE_DATA_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case API_ACTIONS.INITIALIZE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKeyData: action.payload.apiKeyData,
        usageData: action.payload.usageData,
        error: null,
      };
    case API_ACTIONS.INITIALIZE_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Refresh API data
    case API_ACTIONS.REFRESH_DATA_START:
      return {
        ...state,
        refreshing: true,
        error: null,
      };
    case API_ACTIONS.REFRESH_DATA_SUCCESS:
      return {
        ...state,
        refreshing: false,
        apiKeyData: action.payload.apiKeyData,
        usageData: action.payload.usageData,
        error: null,
      };
    case API_ACTIONS.REFRESH_DATA_ERROR:
      return {
        ...state,
        refreshing: false,
        error: action.payload,
      };

    // Update usage data
    case API_ACTIONS.UPDATE_USAGE_START:
      return {
        ...state,
        updatingUsage: true,
        error: null,
      };
    case API_ACTIONS.UPDATE_USAGE_SUCCESS:
      return {
        ...state,
        updatingUsage: false,
        usageData: action.payload,
        error: null,
      };
    case API_ACTIONS.UPDATE_USAGE_ERROR:
      return {
        ...state,
        updatingUsage: false,
        error: action.payload,
      };

    // Clear error
    case API_ACTIONS.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default apiReducer;
